<template>
    <div class="settings-ci-wrapper">
        <loader
            class="loader"
            :class="[isEnhancedLayout ? 'enhanced' : 'classic']"
            v-if="!iframeLoaded"
        ></loader>
        <top-bar-secondary renderCI />
        <input type="hidden" name="id" :value="$root.setting.business_id" />
        <iframe
            v-if="isEnhancedLayout"
            src="/apps/business/business?iframe=true&leftnav=true"
            class="settings-ci-enhanced"
            frameborder="0"
            @load="onIframeLoad"
        />
        <iframe
            v-else
            src="/apps/business/business?iframe=true"
            class="settings-ci-classic"
            frameborder="0"
            @load="onIframeLoad"
        />
    </div>
</template>

<script>
import loader from "@/module/commons/loader.vue";
import TopBarSecondary from "@/module/layout/top-bar-secondary.vue";

export default {
    name: "SettingsCi",
    components: { loader, TopBarSecondary },
    data() {
        return {
            iframeLoaded: false
        };
    },
    watch: {
        "$route.query": {
            immediate: true,
            handler(newQuery) {
                this.sendTabToIframe(newQuery);
            }
        }
    },
    computed: {
        isEnhancedLayout() {
            return this.$store.state.isEnhancedLayout;
        }
    },
    created() {
        this.$root.$on("layout-initialized", () => {
            this.validateEnhancedLayout();
        });
    },
    mounted() {
        if (this.$store.state.isLayoutInitialized) {
            this.validateEnhancedLayout();
        }
    },
    beforeDestroy() {
        this.$root.$off("layout-initialized");
    },
    methods: {
        sendTabToIframe(query) {
            const iframe = document.querySelector("iframe");
            if (iframe?.contentWindow) {
                iframe.contentWindow.postMessage(
                    {
                        tab: query.tab,
                        subtab: query.subtab
                    },
                    "*"
                );
            }
        },
        onIframeLoad() {
            this.iframeLoaded = true;
            if (this.$route.query && "extension" in this.$route.query) {
                this.sendTabToIframe({ tab: "add-ons", subtab: null });
            } else {
                this.sendTabToIframe(this.$route.query); // also send tab on first load
            }
        },
        validateEnhancedLayout() {
            if (!this.isEnhancedLayout) {
                location.href = process.env.APPS + "business/business";
                return;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
$top-bar-primary-height: 64px;
$top-bar-ci-secondary-height: 46px;

.settings-ci-wrapper {
    position: relative;
}
.loader {
    position: absolute;
    z-index: 100;

    &.classic {
        top: $top-bar-primary-height;
    }

    &.enhanced {
        top: $top-bar-ci-secondary-height;
    }
}

.settings-ci-classic {
    width: 100%;
    height: 100vh;
    padding-top: 0;
    border: none;
}

.settings-ci-enhanced {
    width: 100%;
    height: 100vh;
    padding-top: $top-bar-ci-secondary-height;
    border: none;
}

@media screen and (min-width: 992px) {
    .settings-ci-classic {
        padding-top: $top-bar-primary-height;
    }
}
</style>
